import React from "react";

import moment from "moment";

import TextField from "@material-ui/core/TextField";

import { getBenchmarkName } from "../../helpers/nameHelpers";
import { MenuItem } from "@material-ui/core";

const Render = (props) => {
  const { id, actions, state } = props;

  const [decimalOverride, decimalOverride_set] = React.useState(2);
  const [wholeNumberverride, wholeNumberverride_set] = React.useState(true);

  React.useEffect(() => {
    actions.loadReportData(id);
  }, [id]);

  if (!state.reportData) {
    console.log("a");

    return <div style={{ marginTop: 100 }}>Loading...</div>;
  }

  function round(v, d) {
    return parseFloat(Math.round(v.toFixed(d + 1) + "e" + d) + "e-" + d);
  }

  const getPercent = (val, decimals) => {
    if (val) {
      return round(parseFloat(val) * 100, decimals) + "%";
    }

    return "";
  };

  const getNumber = (val, decimals) => {
    if (val) {
      return round(parseFloat(val, 10), decimals);
    }

    return "";
  };

  const getPercent2 = (val, decimals) => {
    if (!wholeNumberverride) {
      return getNumber(val, decimals);
    }
    if (val) {
      return round(parseFloat(val) * 100, decimals) + "%";
    }

    return "";
  };

  const getCurrency = (val) => {
    if (val) {
      return "$" + round(parseFloat(val, 10), 2);
    }

    return "";
  };

  var data = state.reportData.x.data.rowItems;
  var benchmarks = state.reportData.x.benchmarks;
  var summaryData = state.reportData.x;

  const getItem = (
    heading,
    field,
    allowZero = false,
    isPercent = true,
    isCurrency = false,
    isText = false,
    width = 150,
    color = null,
    isDate = false,
    decimals = 2
  ) => {
    return {
      heading,
      field,
      width,
      color,
      allowZero,
      isPercent,
      isCurrency,
      isText,
      decimals,
    };
  };

  const getItem2 = (props) => {
    const {
      heading,
      field,
      allowZero = false,
      isText = false,
      isPercent = true,
      decimals = 4,
      isCurrency = false,
      width = 150,
      color = null,
    } = props;

    return {
      heading,
      field,
      width,
      color,
      allowZero,
      isPercent,
      isCurrency,
      isText,
      decimals,
    };
  };

  const layout = [
    getItem2({
      heading: "Month",
      field: "monthValue",
      decimals: 4,
      isPercent: false,
    }),
    getItem2({ heading: "Date", field: "date", isDate: true }),
    getItem("After Fees Values", "portfolioValue", false, false, true),
    getItem("Contrib", "contributionTotal", false, false, true),
    getItem("WD", "withdrawalTotal", false, false, true),
    getItem("Manager Fees", "feesPaidToManager", false, false, true),
    getItem2({ heading: "Test1", field: "monthProperty", isText: true }),
    getItem2({ heading: "Test2", field: "gM_IRR", isText: true }),
    getItem2({ heading: "Local IRR Inputs1", field: "", isText: true }),
    getItem2({ heading: "Local IRR Inputs2", field: "", isText: true }),

    getItem2({
      heading: "IRR (%/month)",
      field: "irr",
      isPercent: true,
      decimals: 7,
    }),
    getItem2({
      heading: "Ret%/interval",
      field: "ret",
      isPercent: true,
      decimals: 7,
    }),
    getItem("Ret/mo", "retPerMonth", true),
    getItem2({
      heading: "1+Ret",
      field: "onePlusRet",
      isPercent: true,
      decimals: 7,
    }),
    getItem("Cum Ret", "cumRet", true),
    getItem("Annualized", "annualized", true),
    getItem2({ heading: "Before Fees", field: "" }),
    getItem2({
      heading: "Portfolio Value",
      field: "portfolioValue_BeforeFees",
      isCurrency: true,
    }),
    getItem2({
      heading: "IRR, %/mo",
      field: "irR_BeforeFees",
      isPercent: true,
      decimals: 2,
    }),
    getItem2({
      heading: "Ret/interval",
      field: "ret_BeforeFees",
      isPercent: true,
      decimals: 2,
    }),
    getItem2({
      heading: "Ret/mo",
      field: "retPerMonth_BeforeFees",
      isPercent: true,
      decimals: 2,
    }),
    getItem2({
      heading: "1+Ret",
      field: "onePlusRet_BeforeFees",
      isPercent: false,
      decimals: 4,
    }),
    getItem2({
      heading: "Cum Ret",
      field: "cumRet_BeforeFees",
      isPercent: true,
      decimals: 3,
    }),
    getItem2({ heading: "IRR Helpers", field: "" }),
    getItem2({ heading: "IRR Condition", field: "startEnd", isText: true }),
  ];

  const benchmarkLayout = [
    getItem2({
      heading: "Month",
      field: "monthValue",
      decimals: 4,
      isPercent: false,
    }),
    getItem2({ heading: "Date", field: "date", isDate: true }),
    null,
    getItem2({
      heading: "Fees%",
      field: "benchmarkFeePercentage",
      isPercent: true,
      decimals: 3,
    }),
    getItem2({
      heading: "Fees$",
      field: "benchmarkFeeDollars",
      decimals: 3,
      isPercent: false,
    }),
    null,
    getItem2({
      heading: "After Fees Values",
      field: "portfolioValue",
      isCurrency: true,
    }),
    getItem2({
      heading: "Ret/interval",
      field: "ret",
      isPercent: true,
      decimals: 4,
    }),
    getItem2({
      heading: "Ret/mo",
      field: "retPerMonth",
      isPercent: true,
      decimals: 4,
    }),
    getItem2({ heading: "1+Ret", field: "onePlusRet", isPercent: false }),
    getItem2({ heading: "Cum Ret", field: "cumRet", isPercent: true }),
    getItem2({ heading: "Annualized", field: "annualized", isPercent: true }),
    getItem2({ heading: "Before Fees", field: "" }),
    getItem2({
      heading: "Portfolio Value",
      field: "portfolioValue_BeforeFees",
      isCurrency: true,
    }),
    getItem2({
      heading: "Ret/mo",
      field: "retPerMonth_BeforeFees",
      isPercent: true,
      decimals: 4,
    }),
    getItem2({
      heading: "Ret/interval",
      field: "ret_BeforeFees",
      isPercent: true,
      decimals: 4,
    }),
    getItem2({
        heading: "1+Ret",
        field: "onePlusRet_BeforeFees",
        isPercent: false,
        decimals: 4,
      }),
      getItem2({
        heading: "Cum Ret",
        field: "cumRet_BeforeFees",
        isPercent: true,
        decimals: 4,
      }),
      getItem2({
        heading: "Annualized",
        field: "annualized_BeforeFees",
        isPercent: true,
        decimals: 4,
      }),
      getItem2({
        heading: "IRR Cash Flows",
        field: "irrCashFlows_BeforeFees",
        isPercent: false,
        decimals: 4,
      }),
  ];
  
  return (
    <div style={{ fontSize: 14 }}>
      <style>
        {`
                table{
                    border: 1px solid black;
                    border-collapse:collapse;
                }

                td {
                    border-bottom: 1px solid black;
                    border-right: 1px solid #cecece;
                    padding: 4px;
                    white-space: nowrap;
                }

                th {
                    border-bottom: 1px solid black;
                    border-right: 1px solid #cecece;
                    padding: 4px;
                    font-weight: bold;
                }
            `}
      </style>
      <div style={{ margin: 20 }}>
        <TextField
          style={{ width: 300 }}
          label="Decimal Places"
          select
          value={decimalOverride}
          onChange={(e) => {
            decimalOverride_set(e.target.value);
          }}
        >
          <MenuItem value={-1}>Default</MenuItem>
          <MenuItem value={2}>2</MenuItem>
          <MenuItem value={6}>6</MenuItem>
          <MenuItem value={7}>7</MenuItem>
          <MenuItem value={8}>8</MenuItem>
          <MenuItem value={9}>9</MenuItem>
          <MenuItem value={14}>14</MenuItem>
        </TextField>
        <TextField
          style={{ width: 300 }}
          label="Format"
          select
          value={wholeNumberverride}
          onChange={(e) => {
            wholeNumberverride_set(e.target.value);
          }}
        >
          <MenuItem value={true}>Default</MenuItem>
          <MenuItem value={false}>Show all values as Decimal</MenuItem>
        </TextField>
      </div>
      <table>
        <tr style={{ fontWeight: "bold", padding: 10 }}>
          {layout.map((item, i1) => (
            <th key={i1}>{item && item.heading}</th>
          ))}
        </tr>
        {data.map((row, i2) => (
          <tr style={{ padding: 10 }} key={`${i2}_a`}>
            {layout.map((item, i1) => (
              <td key={`${i2}_${i1}a`}>
                {!item || !item.field
                  ? ""
                  : item.isText
                  ? row[item.field]
                  : item.field === "date"
                  ? moment(row[item.field]).format("DD-MMM-YY")
                  : item.isCurrency && wholeNumberverride
                  ? getCurrency(row[item.field])
                  : item.isPercent && wholeNumberverride
                  ? getPercent(
                      row[item.field],
                      decimalOverride > 0 ? decimalOverride : item.decimals
                    )
                  : row[item.field] !== 0
                  ? getNumber(
                      row[item.field],
                      decimalOverride > 0 ? decimalOverride : item.decimals
                    )
                  : item.allowZero
                  ? getNumber(
                      row[item.field],
                      decimalOverride > 0 ? decimalOverride : item.decimals
                    )
                  : ""}
              </td>
            ))}
          </tr>
        ))}
      </table>
      <div style={{ display: "flex", marginTop: 10 }}>
        <div>
          <table border>
            <thead>
              <tr>
                <th></th>
                <th>After Fees/mo</th>
                <th>Before Fees/mo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Avg</td>
                <td>
                  {getPercent2(
                    summaryData.average,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td>
                  {getPercent2(
                    summaryData.average_BeforeFees,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
              </tr>
              <tr>
                <td>Volatility</td>
                <td>
                  {getPercent2(
                    summaryData.volatility,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td>
                  {getPercent2(
                    summaryData.volatility_BeforeFees,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
              </tr>
              <tr>
                <td>Skew</td>
                <td>
                  {getNumber(
                    summaryData.skew,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Max</td>
                <td>
                  {getPercent2(
                    summaryData.max,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Min</td>
                <td>
                  {getPercent2(
                    summaryData.min,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>5% VaR</td>
                <td>
                  {getPercent2(
                    summaryData.fivePercentVar,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>ES</td>
                <td>
                  {getPercent2(
                    summaryData.es,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Autocorr</td>
                <td>
                  {getNumber(
                    summaryData.autoCorr,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ marginLeft: -1 }}>
          <table border>
            <thead>
              <tr>
                <th></th>
                <th>After Fees/mo</th>
                <th>Before Fees/mo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>IRR, %/year</td>
                <td>
                  {getPercent2(
                    summaryData.irrPercentPerYear,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td>
                  {getPercent2(
                    summaryData.irrPercentPerYear_BeforeFees,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
              </tr>
              <tr>
                <td>HPR, %/year</td>
                <td>
                  {getPercent2(
                    summaryData.hprPercentPerYear,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td>
                  {getPercent2(
                    summaryData.hprPercentPerYear_BeforeFees,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
              </tr>
              <tr>
                <td>Sharpe Ratio</td>
                <td>
                  {getNumber(
                    summaryData.sharpeRatio,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Annualized Fees</td>
                <td>
                  {getPercent2(
                    summaryData.annualizedFees,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>MFER</td>
                <td>
                  {getPercent2(
                    summaryData.mfer,
                    decimalOverride > 0 ? decimalOverride : 3
                  )}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {benchmarks.map((bm) => (
        <div key={bm.name}>
          <div style={{ marginTop: 20, fontWeight: "bold", fontSize: 22 }}>
            {getBenchmarkName(bm.name, "CAD")}
          </div>
          <div>Annual fees: {getPercent(bm.annualFee, 3)}</div>
          <div>Monthly fees: {getPercent(bm.monthlyFee, 3)}</div>
          <table>
            <tr>
              {benchmarkLayout.map((item, i1) => (
                <th key={i1}>{item && item.heading}</th>
              ))}
            </tr>
            {bm.benchmarkItems.map((row, i2) => (
              <tr key={`${i2}_a_${bm.name}`}>
                {benchmarkLayout.map((item, i1) => (
                  <td key={`${i2}_${i1}a_${bm.name}`}>
                    {!item || !item.field
                      ? ""
                      : item.isText
                      ? row[item.field]
                      : item.field === "date"
                      ? moment(row[item.field]).format("DD-MMM-YY")
                      : item.isCurrency && wholeNumberverride
                      ? getCurrency(row[item.field])
                      : item.isPercent && wholeNumberverride
                      ? getPercent(
                          row[item.field],
                          decimalOverride > 0 ? decimalOverride : item.decimals
                        )
                      : row[item.field] !== 0
                      ? getNumber(
                          row[item.field],
                          decimalOverride > 0 ? decimalOverride : item.decimals
                        )
                      : item.allowZero
                      ? getNumber(
                          row[item.field],
                          decimalOverride > 0 ? decimalOverride : item.decimals
                        )
                      : ""}
                  </td>
                ))}
              </tr>
            ))}
          </table>
          <div>
            <div style={{ display: "flex", marginTop: 10 }}>
              <div>
                <table border>
                  <thead>
                    <tr>
                      <th></th>
                      <th>After Fees/mo</th>
                      <th>Before Fees/mo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Avg</td>
                      <td>
                        {getPercent2(
                          bm.average,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                      <td>
                        {getPercent2(
                          bm.average_BeforeFees,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Volatility</td>
                      <td>
                        {getPercent2(
                          bm.volatility,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                      <td>
                        {getPercent2(
                          bm.volatility_BeforeFees,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Skew</td>
                      <td>
                        {getNumber(
                          bm.skew,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Max</td>
                      <td>
                        {getPercent2(
                          bm.max,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Min</td>
                      <td>
                        {getPercent2(
                          bm.min,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>5% VaR</td>
                      <td>
                        {getPercent2(
                          bm.fivePercentVar,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>ES</td>
                      <td>
                        {getPercent2(
                          bm.es,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Autocorr</td>
                      <td>
                        {getNumber(
                          bm.autoCorr,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{ marginLeft: -1 }}>
                <table border>
                  <thead>
                    <tr>
                      <th></th>
                      <th>After Fees/mo</th>
                      <th>Before Fees/mo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>IRR, %/year</td>
                      <td>
                        {getPercent2(
                          bm.irrPercentPerYear,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                      <td>
                        {getPercent2(
                          bm.irrPercentPerYear_BeforeFees,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>HPR, %/year</td>
                      <td>
                        {getPercent2(
                          bm.hprPercentPerYear,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                      <td>
                        {getPercent2(
                          bm.hprPercentPerYear_BeforeFees,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Sharpe Ratio</td>
                      <td>
                        {getNumber(
                          bm.sharpeRatio,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>MFER</td>
                      <td>
                        {getPercent2(
                          bm.mfer,
                          decimalOverride > 0 ? decimalOverride : 3
                        )}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Render;



// WEBPACK FOOTER //
// ./src/admin/components/DataAdmin.js